import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Button } from 'antd'
import '../../css/home.scss'
import util from '../../util/util'
import { useHistory } from 'react-router'

const Buttons = (props) => {
  var history = useHistory()

  var handleAddPatient = (e) => {
    history.push({
      pathname: '/patient/add/info',
      state: { home: true },
    })
  }

  return (
    <>
      <Col className='btnContainer' flex={'23%'}>
        <Row>
          <Button onClick={handleAddPatient} className='largeBtn'>
            ADD PATIENT
          </Button>
        </Row>
        <Row>
          <Button disabled className='largeBtn'>
            NOTIFY
          </Button>
        </Row>
      </Col>
    </>
  )
}

Buttons.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string,
  customer: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
  }
}

export default connect(mapStateToProps, null)(Buttons)
